/**
 * Created by slava on 23/10/18
 */

const Heroes = function () {
    this.load();

    // eslint-disable-next-line no-unused-vars
    this.onHeroChangeLevel = function (color) {};

    this.checkAvailableToOpen();
};

Heroes.prototype.load = function () {
    const data = cleverapps.dataLoader.load(DataLoader.TYPES.HEROES);

    if (data === undefined) {
        this.data = {};
        this.save();
    } else {
        this.data = data;
    }
};

Heroes.prototype.getInfo = function () {
    return this.data;
};

Heroes.prototype.updateInfo = function (data, fromServer) {
    this.data = data;
    this.save(fromServer);
};

Heroes.prototype.save = function (fromServer) {
    cleverapps.dataLoader.save(DataLoader.TYPES.HEROES, this.getInfo());

    if (!fromServer) {
        connector.synchronizer.addSendTask("heroes");
    }
};

Heroes.prototype.available = function (options) {
    return levels.user.checkAvailable(cleverapps.config.availables.HEROES, options);
};

Heroes.prototype.checkAvailableToOpen = function () {
    if (!this.available()) {
        return;
    }

    for (const color of Heroes.listOpenColors()) {
        if (!this.getLevel(color)) {
            this.setLevel(color, 1);
        }
    }
};

Heroes.prototype.isHeroAvailable = function (color) {
    return this.data[color] || Heroes.AVAILABLE_HEROES.indexOf(color) !== -1 && Heroes.checkHeroAvailable(color);
};

Heroes.prototype.canUpgradeSomebody = function () {
    for (let i = 0; i < Heroes.AVAILABLE_HEROES.length; i++) {
        if (this.canUpgradeHero(Heroes.AVAILABLE_HEROES[i])) {
            return true;
        }
    }
    return false;
};

Heroes.prototype.getListOfAvailableColors = function () {
    return Object.keys(this.data);
};

Heroes.prototype.getLevel = function (color) {
    if (Heroes.AVAILABLE_HEROES.indexOf(color) < 0) {
        return 0;
    }
    return this.data[color] || 0;
};

Heroes.prototype.getHero = function (color, options) {
    let level = this.getLevel(color);

    if (options && options.nextLevel) {
        level++;
    }

    const data = { level };

    Object.assign(data, HeroesLibrary.byColors[color], HeroesLibrary.levels[color][level]);

    return data;
};

Heroes.prototype.isMaxLevel = function (color) {
    const level = this.getLevel(color);
    return level >= Heroes.HEROES_MAX_LEVEL;
};

Heroes.prototype.expUpgradePrice = function (color) {
    if (HeroesTutorial.getUpgradeHero() === color || HeroesTutorial.getUnlockHero() === color) {
        return 0;
    }

    const level = this.getLevel(color);
    if (level < Heroes.UPGRADE_EXP_PRICE.length) {
        return Heroes.UPGRADE_EXP_PRICE[level];
    }
};

Heroes.prototype.readyToOpen = function () {
    for (const color of Heroes.listOpenColors()) {
        if (this.getLevel(color) === 0 && Heroes.checkHeroAvailable(color)) {
            return color;
        }
    }
};

Heroes.prototype.coinUpgradePrice = function (color) {
    if (HeroesTutorial.getUpgradeHero() === color || HeroesTutorial.getUnlockHero() === color) {
        return 0;
    }

    const level = this.getLevel(color);
    if (level < Heroes.UPGRADE_GOLD_PRICE.length) {
        return Heroes.UPGRADE_GOLD_PRICE[level];
    }
};

Heroes.prototype.canUpgradeHero = function (color) {
    if (this.isMaxLevel(color)) {
        return false;
    }
    const expPrice = this.expUpgradePrice(color);
    return expPrice !== undefined && cleverapps.exp.canTakeExp(expPrice);
};

Heroes.prototype.getCurrentSkin = function () {
    return Heroes.REGULAR_SKIN;
};

Heroes.prototype.listStats = function (color, nextLevel) {
    const hero = this.getHero(color, { nextLevel });
    const stats = {
        level: hero.level,
        numTargets: hero.numTargets,
        power: hero.power
    };
    if (hero.makeHeroProb) {
        stats.makeHeroProb = Math.round(hero.makeHeroProb * 100);
    }
    return stats;
};

Heroes.prototype.incLevel = function (color) {
    this.setLevel(color, this.getLevel(color) + 1);
};

Heroes.prototype.setLevel = function (color, level, silent) {
    this.data[color] = level;
    this.save();
    cleverapps.eventBus.trigger("taskEvent", "UPGRADE_HERO");

    if (!silent) {
        this.onHeroChangeLevel(color);
    }
};

Heroes.prototype.getComics = function (color) {
    return cleverapps.styles.comicses && cleverapps.styles.comicses[color];
};

Heroes.UPGRADE_GOLD_PRICE = [0, 0, 30, 100, 200, 300, 300];
Heroes.UPGRADE_EXP_PRICE = [3, 5, 15, 150, 300, 400, 500];
Heroes.HEROES_MAX_LEVEL = 7;

Heroes.REGULAR_SKIN = "regular";

Heroes.AVAILABLE_HEROES = ["e", "d", "a", "b", "c", "w"];

// a color with no OPEN_HERO_<color> key falls back to the HEROES gate
Heroes.checkHeroAvailable = function (color, options) {
    return levels.user.checkAvailable(cleverapps.config.availables[`OPEN_HERO_${color}`] || cleverapps.config.availables.HEROES, options);
};

Heroes.listOpenColors = function () {
    return Object.keys(cleverapps.config.availables)
        .filter((key) => key.startsWith("OPEN_HERO_"))
        .map((key) => key.slice("OPEN_HERO_".length));
};